exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-container[data-v-7514eab6]{display:inline-block;display:flex;align-items:center}.settings-icon[data-v-7514eab6]{cursor:pointer;opacity:.8;color:var(--coredarkcolor);font-size:14px}.settings-icon.small[data-v-7514eab6]{font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7514eab6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/EditLabelSetting.vue
// module id = 884
// module chunks = 38